import React, { useEffect, useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import OptionList from 'components/common/checklist/OptionList';
import ChecklistOptionHeader from 'components/common/headers/ChecklistOptionHeader';
import { PageWrapper } from 'components/common/checklist/PageWrapper';
import {
  PostSubmitChecklistPageStore,
  PostSubmitChecklistPageStoreContext,
  usePostSubmitChecklistPageStore,
} from 'store/pages/post-submit/post-submit-checklist/pageStore';

const PageHeader: React.FC = observer(() => {
  const { loadInitialData, goBackUrl } = usePostSubmitChecklistPageStore();

  const { periodId } = useParams<{ periodId: string }>();

  useEffect(() => {
    void loadInitialData(periodId);
  }, []);

  const history = useHistory();

  function returnBack(): void {
    history.push(goBackUrl || '');
  }

  return (
    <ChecklistOptionHeader
      title="Post Submission Checklist"
      subtitle="Guided follow up and post submission items"
      backButtonFunc={goBackUrl ? returnBack : undefined}
    />
  );
});

const PageBody: React.FC = observer(() => {
  const { enrollmentCoreData, checklistOptions, enrollmentProposalData, isLoading } = usePostSubmitChecklistPageStore();

  return (
    <OptionList
      enrollmentPeriodId={enrollmentCoreData?.id}
      enrollmentStage={enrollmentCoreData?.stage}
      groupId={enrollmentCoreData?.groupId}
      cartId={enrollmentProposalData?.confirmedProposal?.cartId}
      options={checklistOptions}
      isLoading={isLoading}
    />
  );
});

const PostSubmitChecklistPage: React.FC = () => {
  const pageStore = useMemo(() => new PostSubmitChecklistPageStore(), []);
  return (
    <PostSubmitChecklistPageStoreContext.Provider value={pageStore}>
      <ProposalStatusLayout>
        <PageWrapper>
          <PageHeader />
          <PageBody />
        </PageWrapper>
      </ProposalStatusLayout>
    </PostSubmitChecklistPageStoreContext.Provider>
  );
};

export default PostSubmitChecklistPage;
